import React, { useState, useEffect } from "react";
import axios from "axios";
import AppBar from "@mui/material/AppBar";
import { Input, Select, Button } from "antd";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import "./teamModal.css";

const EditTeam = ({ id, setOpen }) => {
  const countryAPI = process.env.REACT_APP_API_Countries;
  const teamsURL = process.env.REACT_APP_API_Team;
  const [name, setName] = useState("");
  const [country_id, setCountry_id] = useState("");
  const [errors, setErrors] = useState({ name: "", country_id: "", general: "" });
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchCountries();
    fetchTeamInfo();
  }, [id]);

  const fetchTeamInfo = async () => {
    try {
      const response = await axios.get(`${teamsURL}/${id}`);
      const teamData = response.data.body;
      setName(teamData.name || "");
      setCountry_id(teamData.country_id);
    } catch (error) {
      console.error("Error fetching team info:", error);
    }
  };

  const fetchCountries = async () => {
    setLoading(true);
    try {
      const response = await axios.get(countryAPI);
      setCountries(response.data.body || []);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!name?.trim()) newErrors.name = "Please enter the team name";
    if (!country_id) newErrors.country_id = "Please select the country";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setSubmitting(true);
    setErrors({});
    try {
      const response = await axios.put(`${teamsURL}/${id}`, { name: name.trim(), country_id });
      if (response.status === 200) setOpen(false);
      else throw new Error("Failed to update");
    } catch (error) {
      setErrors({ general: "Failed to update team. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <AppBar className="team-modal-appbar" position="relative">
        <Toolbar>
          <Typography className="team-modal-title" variant="h6" component="div" sx={{ flex: 1 }}>
            Edit Team
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
            className="team-modal-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className="team-modal-body">
        <form onSubmit={handleSubmit} className="team-edit-form">
          <div className="team-form-group">
            <label className="team-form-label">Team Name</label>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setErrors((p) => ({ ...p, name: "" }));
              }}
              placeholder="Enter team name"
              className="team-form-input"
              status={errors.name ? "error" : undefined}
            />
            {errors.name && <span className="team-form-error">{errors.name}</span>}
          </div>
          <div className="team-form-group">
            <label className="team-form-label">Country</label>
            <Select
              placeholder="Select country"
              value={country_id}
              onChange={(v) => {
                setCountry_id(v);
                setErrors((p) => ({ ...p, country_id: "" }));
              }}
              className="team-form-select"
              status={errors.country_id ? "error" : undefined}
              loading={loading}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {countries.map((c) => (
                <Select.Option key={c.id} value={c.id}>
                  {c.name}
                </Select.Option>
              ))}
            </Select>
            {errors.country_id && (
              <span className="team-form-error">{errors.country_id}</span>
            )}
          </div>
          {errors.general && (
            <div className="team-form-error-banner">{errors.general}</div>
          )}
          <div className="team-form-actions">
            <Button
              type="default"
              onClick={() => setOpen(false)}
              className="team-btn-cancel"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              className="team-btn-submit"
            >
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditTeam;
